class Driver {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
  }

  name = ''
  surname = ''
  email = ''
  phoneNumber = ''
  password = ''
  carBrand = ''
  carModel = ''
  carYear = ''
  carColorName = ''
  carColorRGB = ''
  drivingHours = ''
  drivingTime = []
  drivingPlatform = []
  driverLicenceImage = null
  driverInsuranceImage = null
  driverRating = null
  sideImage = null
  notification = false

  printData () {
    const string = `Name: ${this.name}, Surname: ${this.surname}\n Email: ${this.email}, Phonenumber: ${this.phoneNumber}, Password: ${this.password}\n 
    Car brand: ${this.carBrand}, Car model: ${this.carModel}, Car year: ${this.carYear}, Car color: ${this.carColorName} - ${this.carColorRGB}\n
    Driving hours: ${this.drivingHours}, Driving time: ${this.drivingTime.forEach(time => console.log(time))}, Driving platform: ${this.drivingPlatform.forEach(platform => console.log(platform))}, referall ${this.referall}\n`
    console.log(string)
  }
}

export default Driver
